export default {
	productIds: [
		'app.cardgames.cribbage.removeads',
		'app.cardgames.cribbage.coins1000',
		'app.cardgames.cribbage.coins5000',
		'app.cardgames.cribbage.coins10000',
		'app.cardgames.cribbage.fullversion'

	]
};
